import Icon from "@/components/ui/Icon";
import type { LinkProps } from "next/link";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { memo } from "react";
import Image, { StaticImageData } from "next/image";

type IndustryButtonLinkProps = {
  imageUrl?: string | StaticImageData;
  imageAlt: string;
} & React.ComponentProps<"a"> &
  LinkProps;

const IndustryButtonLink = ({
  className,
  imageUrl,
  imageAlt,
  href = "#",
  children,
}: IndustryButtonLinkProps) => {
  return (
    <Link
      href={href}
      className={cn(
        "group relative text-semantic-text-secondary flex-auto flex flex-col min-w-0 gap-3 rounded-2xl border bg-white text-lg leading-[130%] py-[11.5px] px-6 md:py-[16.7px] md:pr-13 cursor-pointer lg:text-gray-500 lg:text-lg lg:leading-[150%] lg:font-medium transition-[box-shadow,border-color] border-blue-200 hover:text-gray-800 hover:border-[#2783FF] hover:shadow-[0px_8px_16px_0_rgba(0,0,0,0.08)]",
        className
      )}
    >
      {!!imageUrl && (
        <span className="h-6 relative group-hover:[&>span]:left-[calc(50%-(1.5rem/2))] group-hover:[&>span]:top-[3.5px] md:group-hover:[&>span]:left-0 md:group-hover:[&>span]:top-0">
          <span className="w-6 h-6 shrink-0 absolute left-0 top-0 transition-[left,top] md:static md:transition-none">
            <Image
              alt={imageAlt}
              src={imageUrl}
              width={0}
              height={0}
              className="w-6"
            />
          </span>
        </span>
      )}
      <span className="flex-auto relative min-w-0 group-hover:[&>span:not([aria-hidden='true'])]:left-1/2 group-hover:[&>span:not([aria-hidden='true'])]:top-[-3.5px] group-hover:[&>span:not([aria-hidden='true'])]:[transform:translateX(-50%)] md:group-hover:[&>span:not([aria-hidden='true'])]:left-0 md:group-hover:[&>span:not([aria-hidden='true'])]:top-0 md:group-hover:[&>span:not([aria-hidden='true'])]:[transform:translateX(0)]">
        <span className="opacity-0" aria-hidden="true">
          {children}
        </span>
        <span className="absolute transform left-0 top-0 will-change-transform transition-[left,top,transform] md:transition-none">
          {children}
        </span>
      </span>
      <Icon
        id="icon-arrow-right_24"
        width={24}
        height={24}
        className="shrink-0 opacity-0 transition-opacity text-[#2783FF] hidden md:block md:absolute md:top-[calc(50%-(1.5rem/2))] md:right-6 md:group-hover:opacity-100"
      />
    </Link>
  );
};

export default memo(IndustryButtonLink);
